<template>
  <Card>
    <template #title="">
      <div class="p-d-flex p-justify-between">
        รายละเอียดการฝึกอบรม
        <div>
          <Button
            label="สร้างใหม่"
            icon="pi pi-plus"
            class="p-ml-2"
            @click="onNewTrainingDocument"
          ></Button>
          <back-button class="p-ml-2" v-if="isFullScreen" />
        </div>
      </div>
    </template>
    <template #content>
      <div class="p-grid">
        <div class="p-col-12">
          <div class="p-grid">
            <div class="p-col-12 p-lg-3 p-md-4 p-fluid">
              <div class="p-inputgroup">
                <span class="p-inputgroup-addon">
                  <i class="pi pi-search"></i>
                </span>
                <InputText
                  v-model="searchString"
                  placeholder="ระบุคำค้น"
                ></InputText>
              </div>
            </div>
            <div class="p-col-12 p-lg-3 p-md-4 p-fluid" v-if="isFullScreen">
              <span class="p-float-label">
                <Calendar
                  id="calendar"
                  v-model="filteredDates"
                  selectionMode="range"
                ></Calendar>
                <label for="calendar">ค้นหาจากวันอบรม</label>
              </span>
            </div>
            <div class="p-col-12 p-lg-3 p-md-4" v-if="isFullScreen">
              <Button
                icon="pi pi-search"
                @click="onSearch"
                label="ค้นหาข้อมูล"
              ></Button>
            </div>
          </div>
        </div>
        <div class="p-col-12">
          <DataTable
            :paginator="true"
            :rows="10"
            :rowsPerPageOptions="[10, 20, 50]"
            :value="filteredTrainingDocument"
            class="p-datatable-sm"
            ref="trainingDocumentTable"
            dataKey="id"
          >
            <template #footer=""
              >จำนวนทั้งหมด
              {{ filteredTrainingDocument.length }} รายการ</template
            >
            <template #empty>ไม่พบข้อมูล</template>
            <Column
              field="trainingDocument.id"
              header="เลขที่เอกสาร"
              :sortable="true"
              headerStyle="width: 10rem"
              bodyStyle="width: 10rem"
            >
            </Column>
            <Column header="ประเภทการอบรม" :sortable="true">
              <template #body="slotProps">
                <span>{{
                  trainingTypeDesc(slotProps.data.trainingDocument.trainingType)
                }}</span>
              </template>
            </Column>
            <Column
              field="trainingDocument.courseId"
              header="รหัสหลักสูตร"
              :sortable="true"
            >
            </Column>
            <Column
              field="trainingDocument.course.description"
              header="รายละเอียด"
              :sortable="true"
            >
            </Column>
            <Column header="จากวันที่" :sortable="true">
              <template #body="slotProps">
                <span>{{
                  formatAppDate(slotProps.data.trainingDocument.startDate)
                }}</span>
              </template>
            </Column>
            <Column header="ถึงวันที่" :sortable="true">
              <template #body="slotProps">
                <span>{{
                  formatAppDate(slotProps.data.trainingDocument.endDate)
                }}</span>
              </template>
            </Column>
            <Column
              field="trainingDocument.location"
              header="สถานที่"
              :sortable="true"
            >
            </Column>
            <Column
              header="วิทยากร"
              headerStyle="width: 8rem;"
              bodyStyle="width: 8rem"
            >
              <template #body="props">
                <i
                  v-if="props.data.trainingDocument.internalInstructor1"
                  class="pi pi-user p-mr-2"
                  v-tooltip="
                    `${props.data.trainingDocument.internalInstructor1.prename}${props.data.trainingDocument.internalInstructor1.name} ${props.data.trainingDocument.internalInstructor1.surname}`
                  "
                >
                </i>
                <i
                  v-if="props.data.trainingDocument.internalInstructor2"
                  class="pi pi-user p-mr-2"
                  v-tooltip="
                    `${props.data.trainingDocument.internalInstructor2.prename}${props.data.trainingDocument.internalInstructor2.name} ${props.data.trainingDocument.internalInstructor2.surname}`
                  "
                >
                </i>
                <i
                  v-if="props.data.trainingDocument.internalInstructor3"
                  class="pi pi-user p-mr-2"
                  v-tooltip="
                    `${props.data.trainingDocument.internalInstructor3.prename}${props.data.trainingDocument.internalInstructor3.name} ${props.data.trainingDocument.internalInstructor3.surname}`
                  "
                >
                </i>
                <i
                  v-if="props.data.trainingDocument.instructor1"
                  class="pi pi-user p-mr-2"
                  v-tooltip="`${props.data.trainingDocument.instructor1.name}`"
                ></i>
                <i
                  v-if="props.data.trainingDocument.instructor2"
                  class="pi pi-user p-mr-2"
                  v-tooltip="`${props.data.trainingDocument.instructor2.name}`"
                ></i>
                <i
                  v-if="props.data.trainingDocument.instructor3"
                  class="pi pi-user p-mr-2"
                  v-tooltip="`${props.data.trainingDocument.instructor3.name}`"
                ></i>
              </template>
            </Column>
            <Column header="สถานะ" field="status">
              <template #body="props">
                <StatusBadge
                  :status="props.data.trainingDocument.status"
                ></StatusBadge>
              </template>
              <U></U>
            </Column>
            <Column headerStyle="width: 7rem;" bodyStyle="width: 7rem">
              <template #body="docTraining">
                <Button
                  class="p-button-rounded p-button-success p-mr-2"
                  icon="pi pi-pencil"
                  @click="onEditTrainingDocument(docTraining.data)"
                ></Button>
                <Button
                  class="p-button-rounded p-button-danger"
                  icon="pi pi-trash"
                  @click="onDeleteTrainingDocument(docTraining.data)"
                  :disabled="
                    docTraining.data.trainingDocument.status !== 'บันทึก'
                  "
                ></Button>
              </template>
            </Column>
          </DataTable>
        </div></div
    ></template>
  </Card>
  <Dialog
    header="เพิ่มข้อมูลใหม่"
    v-model:visible="showDialog"
    modal
    style="width: 90vw"
  >
    <div class="p-grid">
      <div class="p-col-12 p-fluid">
        <div class="p-field">
          <span class="p-float-label">
            <InputCourse
              id="newCourseId"
              v-model="trainingDocument.courseId"
              :disabled="!isFullScreen"
            ></InputCourse>
            <label for="newCourseId">หลักสูตร</label>
          </span>
          <small v-if="v$.trainingDocument.courseId.$error" class="p-error">{{
            v$.trainingDocument.courseId.required.$message
          }}</small>
        </div>
      </div>
      <div class="p-col-12 p-lg-6 p-fluid">
        <div class="p-field">
          <label for="trainingType" class="p-text-bold p-invalid"
            >ประเภทการอบรม</label
          >
          <div class="p-grid" id="trainingType">
            <div class="p-col-4">
              <div class="p-field-radiobutton">
                <RadioButton
                  id="internal"
                  name="trainingType"
                  :value="TrainingTypeEnum.Internal"
                  v-model="trainingDocument.trainingType"
                  @change="onInputTrainingType"
                />
                <label for="internal">ภายใน</label>
              </div>
            </div>
            <div class="p-col-4">
              <div class="p-field-radiobutton">
                <RadioButton
                  id="external"
                  name="trainingType"
                  :value="TrainingTypeEnum.External"
                  v-model="trainingDocument.trainingType"
                  @change="onInputTrainingType"
                />
                <label for="external">ภายนอก</label>
              </div>
            </div>
            <div class="p-col-4">
              <div class="p-field-radiobutton">
                <RadioButton
                  id="SiteVisit"
                  name="trainingType"
                  :value="TrainingTypeEnum.SiteVisit"
                  v-model="trainingDocument.trainingType"
                  @change="onInputTrainingType"
                />
                <label for="SiteVisit">ศึกษาดูงาน</label>
              </div>
            </div>
            <small
              v-if="v$.trainingDocument.trainingType.$error"
              class="p-error"
              >{{ v$.trainingDocument.trainingType.required.$message }}</small
            >
          </div>
        </div>
      </div>
      <div class="p-col-12 p-lg-6">
        <div class="p-field">
          <label for="startDate" class="p-text-bold p-mt-0">วันที่อบรม</label>
          <div class="p-fluid">
            <Calendar
              id="startDate"
              v-model="selectedDate"
              selectionMode="range"
              :class="{
                'p-invalid':
                  v$.trainingDocument.startDate.$error ||
                  v$.trainingDocument.endDate.$error,
              }"
            ></Calendar>
          </div>
          <small
            v-if="
              v$.trainingDocument.startDate.$error ||
                v$.trainingDocument.endDate.$error
            "
            class="p-error"
          >
            {{
              v$.trainingDocument.startDate.required.$message ||
                v$.trainingDocument.endDate.required.$message
            }}
          </small>
          <!-- <div class="p-grid" id="startDate">
            <div class="p-col-5">
              <Calendar
                v-model="trainingDocument.startDate"
                dateFormat="yy-mm-dd"
                :monthNavigator="true"
                :yearNavigator="true"
                yearRange="2000:2030"
                :manualInput="false"
                :showIcon="true"
                appendTo="body"
              />
            </div>
            <div class="p-col-2 p-text-center p-mt-3">ถึง</div>
            <div class="p-col-5">
              <Calendar
                id="icon"
                v-model="trainingDocument.endDate"
                dateFormat="yy-mm-dd"
                :monthNavigator="true"
                :yearNavigator="true"
                yearRange="2000:2030"
                :manualInput="false"
                :showIcon="true"
                appendTo="body"
              />
            </div>
          </div> -->
        </div>
      </div>
      <div class="p-col-12 p-md-4 p-fluid">
        <span class="p-float-label">
          <InputMask
            v-model="trainingDocument.time"
            id="time"
            mask="99:99-99:99"
            :class="{ 'p-invalid': v$.trainingDocument.time.$error }"
          ></InputMask>
          <label for="time">ระบุช่วงเวลา</label>
        </span>
        <small
          class="p-error"
          v-for="error in v$.trainingDocument.time.$errors"
          :key="error.$uid"
          >{{ error.$message }}</small
        >
      </div>
      <div class="p-col-12 p-md-4 p-fluid">
        <div class="p-inputgroup">
          <span class="p-float-label">
            <InputNumber
              v-model="trainingDocument.hours"
              id="hours"
              :class="{ 'p-invalid': v$.trainingDocument.hours.$error }"
              mode="decimal"
              :minFractionDigits="2"
            ></InputNumber>
            <label for="hours">จำนวนชั่วโมง</label>
          </span>
          <span class="p-inputgroup-addon">
            ชั่วโมง
          </span>
        </div>

        <small
          class="p-error"
          v-for="error in v$.trainingDocument.hours.$errors"
          :key="error.$uid"
          >{{ error.$message }}</small
        >
      </div>
      <div class="p-col-12 p-md-4 p-fluid">
        <div class="p-field">
          <span class="p-float-label">
            <InputText
              id="location"
              v-model="trainingDocument.location"
              maxlength="100"
              :class="{
                'p-invalid': v$.trainingDocument.location.$error,
              }"
            ></InputText>
            <label for="location">สถานที่</label>
          </span>
          <small class="p-error" v-if="v$.trainingDocument.location.$error">{{
            v$.trainingDocument.location.required.$message
          }}</small>
        </div>
      </div>
      <div class="p-col-12 p-md-4 p-fluid">
        <div class="p-field">
          <span class="p-float-label">
            <InputQuestion
              id="inputQuestion1"
              v-model="trainingDocument.instructorQuestionId"
              :disabled="disableEdit"
              showClear
            ></InputQuestion>
            <label for="inputQuestion1">แบบประเมินวิทยากร</label>
          </span>
        </div>
      </div>

      <div class="p-col-12 p-md-4 p-fluid">
        <div class="p-field">
          <span class="p-float-label">
            <InputQuestion
              id="inputQuestion2"
              v-model="trainingDocument.satisfactionQuestionId"
              :disabled="disableEdit"
              showClear
            ></InputQuestion>
            <label for="inputQuestion2">แบบประเมินความพึงพอใจ</label>
          </span>
        </div>
      </div>

      <div class="p-col-12 p-md-4 p-fluid">
        <div class="p-field">
          <span class="p-float-label">
            <InputQuestion
              id="inputQuestion3"
              v-model="trainingDocument.knowledgeQuestionId"
              :disabled="disableEdit"
              showClear
            ></InputQuestion>
            <label for="inputQuestion3">แบบประเมินความรู้</label>
          </span>
        </div>
      </div>
      <div class="p-col-12 p-md-4 p-fluid">
        <div class="p-field">
          <div
            class="p-inputgroup"
            v-if="!!trainingDocument.instructorQuestionId"
          >
            <span class="p-float-label">
              <InputNumber
                id="instructorWaitingPeriod"
                v-model="trainingDocument.instructorWaitingPeriod"
              ></InputNumber>
              <label for="instructorWaitingPeriod"
                >ทำแบบประเมินวิทยากรได้ใน</label
              >
            </span>
            <span class="p-inputgroup-addon">
              วัน
            </span>
          </div>
        </div>
      </div>
      <div class="p-col-12 p-md-4 p-fluid">
        <div class="p-field">
          <div
            class="p-inputgroup"
            v-if="!!trainingDocument.satisfactionQuestionId"
          >
            <span class="p-float-label">
              <InputNumber
                id="satisfactionWaitingPeriod"
                v-model="trainingDocument.satisfactionWaitingPeriod"
              ></InputNumber>
              <label for="satisfactionWaitingPeriod"
                >ทำแบบประเมินความพึงพอใจได้ใน</label
              >
            </span>
            <span class="p-inputgroup-addon">
              วัน
            </span>
          </div>
        </div>
      </div>
      <div class="p-col-12 p-md-4 p-fluid">
        <div class="p-field">
          <div
            class="p-inputgroup"
            v-if="!!trainingDocument.knowledgeQuestionId"
          >
            <span class="p-float-label">
              <InputNumber
                id="knowledgeWaitingPeriod"
                v-model="trainingDocument.knowledgeWaitingPeriod"
              ></InputNumber>
              <label for="knowledgeWaitingPeriod"
                >ทำแบบประเมินความรู้ได้ใน</label
              >
            </span>
            <span class="p-inputgroup-addon">
              วัน
            </span>
          </div>
        </div>
      </div>
      <template
        v-if="trainingDocument.trainingType === TrainingTypeEnum.Internal"
      >
        <div class="p-col-12 p-lg-4 p-md-6 p-fluid">
          <div class="p-field">
            <span class="p-float-label">
              <InputUser
                id="InputUser1"
                v-model="trainingDocument.internalInstructorId1"
                :disabled="disableEdit"
              ></InputUser>
              <label for="InputUser1">วิทยากรภายใน 1</label>
            </span>
          </div>
        </div>
        <div class="p-col-12 p-lg-4 p-md-6 p-fluid">
          <div class="p-field">
            <span class="p-float-label">
              <InputUser
                id="InputUser2"
                v-model="trainingDocument.internalInstructorId2"
                :disabled="disableEdit"
              ></InputUser>
              <label for="InputUser2">วิทยากรภายใน 2</label>
            </span>
          </div>
        </div>
        <div class="p-col-12 p-lg-4 p-md-6 p-fluid">
          <div class="p-field">
            <span class="p-float-label">
              <InputUser
                id="InputUser3"
                v-model="trainingDocument.internalInstructorId3"
                :disabled="disableEdit"
              ></InputUser>
              <label for="InputUser3">วิทยากรภายใน 3</label>
            </span>
          </div>
        </div>
      </template>
      <div class="p-col-12 p-lg-4 p-md-6 p-fluid">
        <div class="p-field">
          <span class="p-float-label">
            <InputInstructor
              id="inputInstructor1"
              v-model="trainingDocument.instructorId1"
              :disabled="disableEdit"
            ></InputInstructor>
            <label for="inputInstructor1">วิทยากรภายนอก 1</label>
          </span>
        </div>
      </div>
      <div class="p-col-12 p-lg-4 p-md-6 p-fluid">
        <div class="p-field">
          <span class="p-float-label">
            <InputInstructor
              id="inputInstructor2"
              v-model="trainingDocument.instructorId2"
              :disabled="disableEdit"
            ></InputInstructor>
            <label for="inputInstructor2">วิทยากรภายนอก 2</label>
          </span>
        </div>
      </div>
      <div class="p-col-12 p-lg-4 p-md-6 p-fluid">
        <div class="p-field">
          <span class="p-float-label">
            <InputInstructor
              id="inputInstructor3"
              v-model="trainingDocument.instructorId3"
              :disabled="disableEdit"
            ></InputInstructor>
            <label for="inputInstructor3">วิทยากรภายนอก 3</label>
          </span>
        </div>
      </div>
      <div class="p-col-12 p-lg-4 p-md-6 p-fluid">
        <div class="p-field">
          <span class="p-float-label">
            <InputNumber
              id="inputDunning1"
              v-model="trainingDocument.dunning1"
              :disabled="disableEdit"
              :class="{ 'p-invalid': v$.trainingDocument.dunning1.$error }"
            ></InputNumber>
            <label for="inputDunning1">จำนวนวันติดตามงานครั้งที่ 1</label>
          </span>
        </div>
        <small
          class="p-error"
          v-for="error in v$.trainingDocument.dunning1.$errors"
          :key="error.$uid"
          >{{ error.$message }}</small
        >
      </div>
      <div class="p-col-12 p-lg-4 p-md-6 p-fluid">
        <div class="p-field">
          <span class="p-float-label">
            <InputNumber
              id="inputDunning2"
              v-model="trainingDocument.dunning2"
              :disabled="disableEdit"
              :class="{ 'p-invalid': v$.trainingDocument.dunning2.$error }"
            ></InputNumber>
            <label for="inputDunning2">จำนวนวันติดตามงานครั้งที่ 2</label>
          </span>
        </div>
        <small
          class="p-error"
          v-for="error in v$.trainingDocument.dunning2.$errors"
          :key="error.$uid"
          >{{ error.$message }}</small
        >
      </div>
      <div class="p-col-12 p-fluid p-field">
        <label for="remark">รายละเอียดอื่น ๆ</label>
        <Textarea
          id="remark"
          v-model="trainingDocument.remark"
          style="width: 100%"
          :rows="5"
          :disabled="disableEdit"
        ></Textarea>
      </div>
    </div>

    <template #footer>
      <Button
        icon="pi pi-check"
        label="ยืนยัน"
        class="p-button-success"
        @click="onSaveTrainingDocument"
      ></Button>
      <Button
        icon="pi pi-times"
        label="ยกเลิก"
        class="p-button-danger p-ml-2"
        @click="onHideDialog"
      ></Button>
    </template>
  </Dialog>
  <!-- <Dialog
    v-model:visible="popupDeleteDialog"
    :style="{ width: '450px' }"
    header="Confirm"
    :modal="true"
  >
    <div class="confirmation-content">
      <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
      <span v-if="trainingDocument"
        >Are you sure you want to delete <b>{{ trainingDocument.id }}</b
        >?</span
      >
    </div>
    <template #footer>
      <Button
        label="No"
        icon="pi pi-times"
        class="p-button-text"
        @click="popupDeleteDialog = false"
      />
      <Button
        label="Yes"
        icon="pi pi-check"
        class="p-button-text"
        @click="handleDeleteTrainingDocument"
      />
    </template>
  </Dialog> -->
</template>

<script lang="ts">
import {
  defineComponent,
  ref,
  computed,
  PropType,
  onMounted,
  watch,
} from "vue";
import { usePlugin } from "@/plugins";
import {
  TrainingDocument,
  Course,
  UpsertTrainingDocumentRequest,
  TrainingTypeEnum,
  TrainingDocumentDetailDto,
  CourseDetailDto,
  GetTrainingDocumentRequest,
  GetTrainingDocumentResponse,
  ConfigQuestionSet,
  GetConfigQuestionSetResponse,
  UpsertTrainingDocumentResponse,
} from "@/types";
import Fuse from "fuse.js";
import { clone } from "ramda";
import InputInstructor from "@/components/InputInstructor.vue";
import BackButton from "./BackButton.vue";
import InputCourse from "@/components/InputCourse.vue";
import InputUser from "@/components/InputUser.vue";
import InputQuestion from "@/components/InputQuestion.vue";
import StatusBadge from "@/components/StatusBadge.vue";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";

export default defineComponent({
  name: "TrainingDocumentList",
  props: {
    items: Array as PropType<TrainingDocumentDetailDto[]>,
    course: {} as PropType<Course>,
  },
  components: {
    InputCourse,
    InputInstructor,
    InputQuestion,
    InputUser,
    BackButton,
    StatusBadge,
  },
  emit: ["newTrainingDocument"],
  setup(props) {
    const {
      success,
      error,
      axios,
      setLoading,
      onRouterPush,
      trainingTypeDesc,
      confirmation,
      formatAppDate,
      dayjs,
    } = usePlugin();

    const isFullScreen = computed(() => props.course === undefined);
    const filteredDates = ref<Date[]>([
      dayjs()
        .startOf("month")
        .toDate(),
      dayjs()
        .endOf("month")
        .toDate(),
    ]);
    const trainingDocuments = ref<TrainingDocumentDetailDto[]>([]);
    const trainingDocument = ref<TrainingDocument>({} as TrainingDocument);
    const selectedDate = ref<Date[]>([dayjs().toDate(), dayjs().toDate()]);
    watch(
      () => selectedDate.value,
      () => {
        trainingDocument.value.startDate = selectedDate.value[0];
        trainingDocument.value.endDate = selectedDate.value[1];
      }
    );

    const showDialog = ref(false);
    // const popupDeleteDialog = ref(false);
    const searchString = ref("");
    const submitted = ref(false);
    const disableEdit = ref(false);

    const newRules = {
      trainingDocument: {
        trainingType: { required },
        courseId: { required },
        location: { required },
        startDate: { required },
        endDate: { required },
        time: { required },
        hours: { required },
        dunning1: { required },
        dunning2: { required },
      },
    };
    const v$ = useVuelidate(newRules, { trainingDocument });

    const filteredTrainingDocument = computed(() => {
      if (!searchString.value) return trainingDocuments.value;
      const fuse = new Fuse(trainingDocuments.value, {
        keys: [
          "trainingDocument.id",
          "trainingDocument.courseId",
          "trainingDocument.course.description",
        ],
      });
      const searchResult = fuse.search(searchString.value);
      return searchResult.map((x) => x.item);
    });

    const onSaveTrainingDocument = async () => {
      v$.value.$touch();
      if (v$.value.$invalid) return;

      submitted.value = true;
      setLoading(true);
      const trainingDocumentUpdate = {
        id: "",
        courseId: trainingDocument.value.courseId,
        startDate: selectedDate.value[0],
        endDate: selectedDate.value[1],
        location: trainingDocument.value.location,
        course: trainingDocument.value.course,
        trainingType: trainingDocument.value.trainingType,
        instructorQuestionId: trainingDocument.value.instructorQuestionId,
        satisfactionQuestionId: trainingDocument.value.satisfactionQuestionId,
        knowledgeQuestionId: trainingDocument.value.knowledgeQuestionId,
        instructorWaitingPeriod: trainingDocument.value.instructorWaitingPeriod,
        satisfactionWaitingPeriod:
          trainingDocument.value.satisfactionWaitingPeriod,
        knowledgeWaitingPeriod: trainingDocument.value.knowledgeWaitingPeriod,
        instructorId1: trainingDocument.value.instructorId1,
        instructorId2: trainingDocument.value.instructorId2,
        instructorId3: trainingDocument.value.instructorId3,
        internalInstructorId1: trainingDocument.value.internalInstructorId1,
        internalInstructorId2: trainingDocument.value.internalInstructorId2,
        internalInstructorId3: trainingDocument.value.internalInstructorId3,
        dunning1: trainingDocument.value.dunning1,
        dunning2: trainingDocument.value.dunning2,
        hours: trainingDocument.value.hours,
        time: trainingDocument.value.time,
        remark: trainingDocument.value.remark,
      } as TrainingDocument;

      try {
        const result = await axios.post<UpsertTrainingDocumentResponse>(
          "api/v1/services/trainingDocument/upsert",
          {
            trainingDocuments: [trainingDocumentUpdate],
          } as UpsertTrainingDocumentRequest
        );
        success("บันทึกข้อมูลสำเร็จแล้ว");
        showDialog.value = false;
        if (result.data.trainingDocument?.id) {
          onRouterPush({
            name: "editTrainingDocument",
            params: { docNo: result.data.trainingDocument.id },
          });
        } else {
          await loadTrainingDocuments();
        }
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };

    const onHideDialog = () => {
      showDialog.value = false;
      submitted.value = false;
    };

    const onNewTrainingDocument = async () => {
      v$.value.$reset();
      trainingDocument.value = {
        course: props.course,
        courseId: props.course?.id,
        trainingType: TrainingTypeEnum.Internal,
        startDate: selectedDate.value[0],
        endDate: selectedDate.value[1],
      } as TrainingDocument;
      trainingDocument.value.instructorQuestionId =
        questionSet.value?.instructorQuestionId ?? null;
      trainingDocument.value.satisfactionQuestionId =
        questionSet.value?.satisfactionQuestionId ?? null;
      trainingDocument.value.knowledgeQuestionId =
        questionSet.value?.knowledgeQuestionId ?? null;
      trainingDocument.value.instructorWaitingPeriod =
        questionSet.value?.instructorWaitingPeriod ?? null;
      trainingDocument.value.satisfactionWaitingPeriod =
        questionSet.value?.satisfactionWaitingPeriod ?? null;
      trainingDocument.value.knowledgeWaitingPeriod =
        questionSet.value?.knowledgeWaitingPeriod ?? null;
      trainingDocument.value.dunning1 = questionSet.value?.dunning1 ?? null;
      trainingDocument.value.dunning2 = questionSet.value?.dunning2 ?? null;
      showDialog.value = true;
      submitted.value = false;
    };

    const questionSet = computed(() => {
      var question = questionSets.value.filter(
        (x) => x.trainingType === trainingDocument.value.trainingType
      );
      return question.length > 0 ? question[0] : null;
    });

    const onEditTrainingDocument = async (
      source: TrainingDocumentDetailDto
    ) => {
      onRouterPush({
        name: "editTrainingDocument",
        params: {
          // id: props.course?.id ?? "",
          docNo: source.trainingDocument?.id ?? "",
        },
      });
    };

    const onDeleteTrainingDocument = async (
      source: TrainingDocumentDetailDto
    ) => {
      trainingDocument.value = clone(
        source.trainingDocument ?? ({} as TrainingDocument)
      );

      confirmation.require({
        header: "ลบเอกสาร",
        message: `กรุณายืนยันเพื่อลบเอกสาร ${trainingDocument.value.id} ?`,
        acceptLabel: "ลบเอกสาร",
        accept: () => handleDeleteTrainingDocument(),
        rejectLabel: "ปิด",
      });
    };

    const loadTrainingDocuments = async () => {
      setLoading(true);
      try {
        const result = await axios.get<CourseDetailDto>(
          `api/v1/services/course/${props.course?.id}`
        );
        trainingDocuments.value = result.data.trainingDocumentDtos ?? [];
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };

    onMounted(async () => {
      trainingDocuments.value = clone(props.items) ?? [];
      if (isFullScreen.value === true) {
        onSearch();
      }
    });

    const handleDeleteTrainingDocument = async () => {
      setLoading(true);
      try {
        await axios.delete("api/v1/services/trainingDocument/delete", {
          data: {
            trainingDocuments: [trainingDocument.value],
          } as UpsertTrainingDocumentRequest,
        });
        await loadTrainingDocuments();
        if (isFullScreen.value === true) {
          onSearch();
        }
        success("ลบข้อมูลสำเร็จแล้ว");
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
      // }
    };

    const onSearch = async () => {
      setLoading(true);
      try {
        var result = await axios.post<GetTrainingDocumentResponse>(
          "api/v1/services/trainingDocument/get",
          {
            fromDate: dayjs(filteredDates.value[0]).toISOString(),
            toDate: dayjs(filteredDates.value[1]).toISOString(),
            searchString: searchString.value,
          } as GetTrainingDocumentRequest
        );
        trainingDocuments.value = (result.data.trainingDocuments ?? []).map(
          (x) => {
            return {
              trainingDocument: x,
            } as TrainingDocumentDetailDto;
          }
        );
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };

    const questionSets = ref<ConfigQuestionSet[]>([]);
    const loadQuestionSet = async () => {
      setLoading(true);
      try {
        const result = await axios.post<GetConfigQuestionSetResponse>(
          "api/v1/services/configQuestionSet",
          {}
        );
        questionSets.value = result.data.configQuestionSets ?? [];
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };

    const onInputTrainingType = () => {
      trainingDocument.value.instructorQuestionId =
        questionSet.value?.instructorQuestionId ?? null;
      trainingDocument.value.satisfactionQuestionId =
        questionSet.value?.satisfactionQuestionId ?? null;
      trainingDocument.value.knowledgeQuestionId =
        questionSet.value?.knowledgeQuestionId ?? null;
      trainingDocument.value.instructorWaitingPeriod =
        questionSet.value?.instructorWaitingPeriod ?? null;
      trainingDocument.value.satisfactionWaitingPeriod =
        questionSet.value?.satisfactionWaitingPeriod ?? null;
      trainingDocument.value.knowledgeWaitingPeriod =
        questionSet.value?.knowledgeWaitingPeriod ?? null;
    };

    onMounted(async () => {
      await loadQuestionSet();
    });

    return {
      onNewTrainingDocument,
      onEditTrainingDocument,
      onDeleteTrainingDocument,
      searchString,
      filteredTrainingDocument,
      trainingDocument,
      submitted,
      onHideDialog,
      showDialog,
      onSaveTrainingDocument,

      handleDeleteTrainingDocument,
      TrainingTypeEnum,
      formatAppDate,
      trainingTypeDesc,
      disableEdit,
      isFullScreen,
      filteredDates,
      onSearch,
      selectedDate,
      v$,
      onInputTrainingType,
    };
  },
});
</script>

<style></style>
